import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ActiveUserStore } from '../stores/user/active-user.state';
import { CommuneStore } from '../stores/commune/commune.state';
// restart ng serve on changes! gets cached...
export const routeContextGuard: CanActivateFn = async route => {
  const userStore = inject(ActiveUserStore);
  const communeStore = inject(CommuneStore);

  const context = route.data?.['context'];

  if (context === 'atlasInternal' || context === 'dataBackend') {
    userStore.setContext(context);
    return true;
  }

  const slug = route.params['slug'];

  if (context === 'atlasExternal' && slug) {
    const commune = await communeStore.findBySlug(slug);
    if (!commune) {
      userStore.loginRedirect(); // todo: redirect to 404? With Quick-Links?
      return false;
    }
    userStore.setContext(context);
    userStore.setPublicCommune(commune._id, commune.slug);
    return true;
  } else {
    userStore.loginRedirect();
    return false;
  }
};
